import React, {
    useMemo,
    useState,
    useEffect
} from "react";


const AdminAnnouncements = () => {

    const [subject, setSubject] =
        useState("");

    const [title, setTitle] =
        useState("");

    const [message, setMessage] =
        useState("");

    const [testEmail, setTestEmail] =
        useState("");

    const [loadingAction, setLoadingAction] =
        useState("");

    const [success, setSuccess] =
        useState("");

    const [error, setError] =
        useState("");

    const [showConfirmModal, setShowConfirmModal] =
        useState(false);


    const token =
        localStorage.getItem(
            "authToken"
        );


    const authHeader =
        useMemo(() => {

            if (!token) {
                return "";
            }

            return token.startsWith(
                "Bearer "
            )
                ? token
                : `Bearer ${token}`;

        }, [token]);


    const isFormValid =
        subject.trim() &&
        title.trim() &&
        message.trim();


    // =========================================================
    // SEND TEST
    // =========================================================

    const sendTestEmail =
        async () => {

            if (
                !isFormValid ||
                !testEmail.trim()
            ) {
                return;
            }


            try {

                setLoadingAction(
                    "TEST"
                );

                setError("");
                setSuccess("");


                const response =
                    await fetch(
                        `${process.env.REACT_APP_API_URL}/api/admin/broadcast/test`,
                        {
                            method: "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",

                                Authorization:
                                    authHeader
                            },

                            body:
                                JSON.stringify({
                                    email:
                                        testEmail.trim(),

                                    subject:
                                        subject.trim(),

                                    title:
                                        title.trim(),

                                    message:
                                        message.trim()
                                })
                        }
                    );


                const data =
                    await response
                        .json()
                        .catch(() => null);


                if (!response.ok) {

                    throw new Error(
                        data?.message ||
                        "Unable to send test email."
                    );
                }


                setSuccess(
                    data?.message ||
                    "Test email queued successfully."
                );
                setTestEmail("");


            } catch (error) {

                console.error(
                    "Broadcast test error:",
                    error
                );

                setError(
                    error?.message ||
                    "Unable to send test email."
                );


            } finally {

                setLoadingAction(
                    ""
                );
            }
        };


    // =========================================================
    // OPEN SEND-ALL CONFIRMATION
    // =========================================================

    const openSendAllModal = () => {

        if (!isFormValid) {
            return;
        }

        setError("");
        setSuccess("");

        setShowConfirmModal(
            true
        );
    };


    // =========================================================
    // SEND TO ALL USERS
    // =========================================================

    const sendToAllUsers =
        async () => {

            if (!isFormValid) {
                return;
            }


            try {

                setLoadingAction(
                    "ALL"
                );

                setError("");
                setSuccess("");


                const response =
                    await fetch(
                        `${process.env.REACT_APP_API_URL}/api/admin/broadcast/send`,
                        {
                            method: "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",

                                Authorization:
                                    authHeader
                            },

                            body:
                                JSON.stringify({
                                    subject:
                                        subject.trim(),

                                    title:
                                        title.trim(),

                                    message:
                                        message.trim()
                                })
                        }
                    );


                const data =
                    await response
                        .json()
                        .catch(() => null);


                if (!response.ok) {

                    throw new Error(
                        data?.message ||
                        "Unable to send broadcast."
                    );
                }


                setShowConfirmModal(
                    false
                );


                setSuccess(
                    data?.message ||
                    "Broadcast queued for all users."
                );

                setSubject("");
                setTitle("");
                setMessage("");
                setTestEmail("");


            } catch (error) {

                console.error(
                    "Broadcast send error:",
                    error
                );

                setError(
                    error?.message ||
                    "Unable to send broadcast."
                );


            } finally {

                setLoadingAction(
                    ""
                );
            }
        };


    useEffect(() => {

        const html =
            document.documentElement;

        const body =
            document.body;

        const root =
            document.getElementById("root");


        const oldHtmlOverflow =
            html.style.overflow;

        const oldBodyOverflow =
            body.style.overflow;

        const oldRootOverflow =
            root?.style.overflow;


        html.style.overflowY =
            "auto";

        html.style.overflowX =
            "hidden";

        body.style.overflowY =
            "auto";

        body.style.overflowX =
            "hidden";

        body.style.height =
            "auto";

        body.style.minHeight =
            "100vh";


        if (root) {

            root.style.overflowY =
                "visible";

            root.style.overflowX =
                "hidden";

            root.style.height =
                "auto";

            root.style.minHeight =
                "100vh";
        }


        return () => {

            html.style.overflow =
                oldHtmlOverflow;

            body.style.overflow =
                oldBodyOverflow;

            if (root) {
                root.style.overflow =
                    oldRootOverflow || "";
            }
        };

    }, []);

    return (

        <main
            style={{
                width: "100%",
                minHeight: "100vh",
                background: "#f8fafc",
                padding: "30px",
                paddingBottom: "120px",
                boxSizing: "border-box",
                overflowX: "hidden"
            }}
        >

            <div
                style={{
                    maxWidth: "1050px",
                    margin: "0 auto"
                }}
            >

                {/* HEADER */}

                <div
                    style={{
                        marginBottom: "28px"
                    }}
                >

                    <div
                        style={{
                            display: "inline-flex",
                            padding: "7px 12px",
                            borderRadius: "999px",
                            background: "#fdf2f8",
                            color: "#be185d",
                            fontSize: "12px",
                            fontWeight: "800",
                            marginBottom: "10px"
                        }}
                    >
                        ANNOUNCEMENTS
                    </div>


                    <h1
                        style={{
                            margin: 0,
                            fontSize: "32px",
                            color: "#0f172a"
                        }}
                    >
                        Broadcast Email
                    </h1>


                    <p
                        style={{
                            marginTop: "8px",
                            color: "#64748b"
                        }}
                    >
                        Send announcements and product updates
                        to the HalalHeart community.
                    </p>

                </div>


                {/* MESSAGES */}

                {success && (

                    <div
                        style={{
                            marginBottom: "18px",
                            padding: "14px 16px",
                            borderRadius: "12px",
                            background: "#ecfdf5",
                            border:
                                "1px solid #bbf7d0",
                            color: "#166534",
                            fontWeight: "700"
                        }}
                    >
                        {success}
                    </div>

                )}


                {error && (

                    <div
                        style={{
                            marginBottom: "18px",
                            padding: "14px 16px",
                            borderRadius: "12px",
                            background: "#fef2f2",
                            border:
                                "1px solid #fecaca",
                            color: "#b91c1c",
                            fontWeight: "700"
                        }}
                    >
                        {error}
                    </div>

                )}


                {/* COMPOSER */}

                <div
                    style={{
                        background: "#fff",
                        border:
                            "1px solid #e2e8f0",
                        borderRadius: "20px",
                        padding: "24px",
                        boxShadow:
                            "0 7px 24px rgba(15,23,42,.04)"
                    }}
                >

                    <FieldLabel>
                        Subject
                    </FieldLabel>

                    <input
                        type="text"
                        value={subject}
                        onChange={e =>
                            setSubject(
                                e.target.value
                            )
                        }
                        placeholder="New features are live on HalalHeart ❤️"
                        style={inputStyle}
                    />


                    <div
                        style={{
                            height: "18px"
                        }}
                    />


                    <FieldLabel>
                        Email title
                    </FieldLabel>

                    <input
                        type="text"
                        value={title}
                        onChange={e =>
                            setTitle(
                                e.target.value
                            )
                        }
                        placeholder="Discover what's new on HalalHeart!"
                        style={inputStyle}
                    />


                    <div
                        style={{
                            height: "18px"
                        }}
                    />


                    <FieldLabel>
                        Message
                    </FieldLabel>

                    <textarea
                        value={message}
                        onChange={e =>
                            setMessage(
                                e.target.value
                            )
                        }
                        placeholder={
                            "You can now go Live and connect with the community.\n\n" +
                            "Receive Gifts during your Live sessions and earn creator earnings.\n\n" +
                            "Create and share Moments.\n\n" +
                            "Use our reporting tools to help keep HalalHeart safe."
                        }
                        rows={12}
                        style={{
                            ...inputStyle,
                            resize: "vertical",
                            lineHeight: "1.6"
                        }}
                    />


                    {/* TEST SECTION */}

                    <div
                        style={{
                            marginTop: "28px",
                            paddingTop: "24px",
                            borderTop:
                                "1px solid #e2e8f0"
                        }}
                    >

                        <h3
                            style={{
                                margin:
                                    "0 0 6px",
                                color: "#0f172a"
                            }}
                        >
                            Send a test first
                        </h3>


                        <p
                            style={{
                                margin:
                                    "0 0 14px",
                                color: "#64748b",
                                fontSize: "14px"
                            }}
                        >
                            Review the email in your inbox before
                            sending it to everyone.
                        </p>


                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                flexWrap: "wrap"
                            }}
                        >

                            <input
                                type="email"
                                value={testEmail}
                                onChange={e =>
                                    setTestEmail(
                                        e.target.value
                                    )
                                }
                                placeholder="admin@example.com"
                                style={{
                                    ...inputStyle,
                                    flex: "1 1 300px"
                                }}
                            />


                            <button
                                type="button"
                                disabled={
                                    !isFormValid ||
                                    !testEmail.trim() ||
                                    Boolean(
                                        loadingAction
                                    )
                                }
                                onClick={
                                    sendTestEmail
                                }
                                style={{
                                    border:
                                        "1px solid #cbd5e1",
                                    background: "#fff",
                                    color: "#334155",
                                    padding:
                                        "11px 18px",
                                    borderRadius:
                                        "10px",
                                    fontWeight:
                                        "800",
                                    cursor:
                                        !isFormValid ||
                                            !testEmail.trim() ||
                                            Boolean(
                                                loadingAction
                                            )
                                            ? "not-allowed"
                                            : "pointer",
                                    opacity:
                                        !isFormValid ||
                                            !testEmail.trim() ||
                                            Boolean(
                                                loadingAction
                                            )
                                            ? 0.55
                                            : 1
                                }}
                            >
                                {
                                    loadingAction ===
                                        "TEST"
                                        ? "Sending..."
                                        : "Send Test"
                                }
                            </button>

                        </div>

                    </div>


                    {/* SEND ALL */}

                    <div
                        style={{
                            marginTop: "28px",
                            display: "flex",
                            justifyContent:
                                "flex-end"
                        }}
                    >

                        <button
                            type="button"
                            disabled={
                                !isFormValid ||
                                Boolean(
                                    loadingAction
                                )
                            }
                            onClick={
                                openSendAllModal
                            }
                            style={{
                                border: "none",
                                background:
                                    !isFormValid ||
                                        Boolean(
                                            loadingAction
                                        )
                                        ? "#f9a8d4"
                                        : "#ec4899",
                                color: "#fff",
                                padding:
                                    "12px 22px",
                                borderRadius:
                                    "10px",
                                fontWeight:
                                    "800",
                                cursor:
                                    !isFormValid ||
                                        Boolean(
                                            loadingAction
                                        )
                                        ? "not-allowed"
                                        : "pointer"
                            }}
                        >
                            Send to All Users
                        </button>

                    </div>

                </div>

            </div>


            {/* CONFIRM MODAL */}

            {showConfirmModal && (

                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background:
                            "rgba(15,23,42,.58)",
                        backdropFilter:
                            "blur(4px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent:
                            "center",
                        zIndex: 9999,
                        padding: "20px"
                    }}
                >

                    <div
                        style={{
                            width: "100%",
                            maxWidth: "470px",
                            background: "#fff",
                            borderRadius: "20px",
                            padding: "24px",
                            boxShadow:
                                "0 25px 70px rgba(0,0,0,.25)"
                        }}
                    >

                        <div
                            style={{
                                width: "48px",
                                height: "48px",
                                borderRadius: "50%",
                                background: "#fce7f3",
                                display: "flex",
                                alignItems: "center",
                                justifyContent:
                                    "center",
                                fontSize: "22px",
                                marginBottom: "15px"
                            }}
                        >
                            ✉️
                        </div>


                        <h2
                            style={{
                                margin:
                                    "0 0 8px",
                                color: "#0f172a"
                            }}
                        >
                            Send announcement to all users?
                        </h2>


                        <p
                            style={{
                                margin:
                                    "0 0 18px",
                                color: "#64748b",
                                lineHeight: "1.6"
                            }}
                        >
                            This will queue the email for every
                            HalalHeart user with an email address.
                            Make sure you already reviewed the test
                            email.
                        </p>


                        <div
                            style={{
                                background: "#f8fafc",
                                border:
                                    "1px solid #e2e8f0",
                                borderRadius: "12px",
                                padding: "14px",
                                marginBottom: "20px"
                            }}
                        >

                            <div
                                style={{
                                    fontSize: "12px",
                                    color: "#94a3b8",
                                    marginBottom: "4px"
                                }}
                            >
                                SUBJECT
                            </div>

                            <strong>
                                {subject}
                            </strong>

                        </div>


                        <div
                            style={{
                                display: "flex",
                                justifyContent:
                                    "flex-end",
                                gap: "10px"
                            }}
                        >

                            <button
                                type="button"
                                disabled={
                                    loadingAction ===
                                    "ALL"
                                }
                                onClick={() =>
                                    setShowConfirmModal(
                                        false
                                    )
                                }
                                style={{
                                    border:
                                        "1px solid #cbd5e1",
                                    background: "#fff",
                                    padding:
                                        "10px 16px",
                                    borderRadius:
                                        "10px",
                                    fontWeight:
                                        "700",
                                    cursor:
                                        "pointer"
                                }}
                            >
                                Cancel
                            </button>


                            <button
                                type="button"
                                disabled={
                                    loadingAction ===
                                    "ALL"
                                }
                                onClick={
                                    sendToAllUsers
                                }
                                style={{
                                    border: "none",
                                    background:
                                        "#ec4899",
                                    color: "#fff",
                                    padding:
                                        "10px 18px",
                                    borderRadius:
                                        "10px",
                                    fontWeight:
                                        "800",
                                    cursor:
                                        loadingAction ===
                                            "ALL"
                                            ? "wait"
                                            : "pointer"
                                }}
                            >
                                {
                                    loadingAction ===
                                        "ALL"
                                        ? "Queueing..."
                                        : "Yes, Send to All"
                                }
                            </button>

                        </div>

                    </div>

                </div>

            )}

        </main>
    );
};


const FieldLabel = ({
    children
}) => (

    <label
        style={{
            display: "block",
            marginBottom: "7px",
            fontSize: "13px",
            color: "#334155",
            fontWeight: "800"
        }}
    >
        {children}
    </label>
);


const inputStyle = {
    width: "100%",
    boxSizing: "border-box",
    padding: "12px 14px",
    border: "1px solid #cbd5e1",
    borderRadius: "11px",
    outline: "none",
    fontSize: "14px",
    fontFamily: "inherit"
};


export default AdminAnnouncements;